import { NavLink } from "react-router-dom";

const HealthActionBar = ({ onAction = (actionKey) => { } }) => {

    return (
        <div className="mt-2">
            <small className="text-muted">Quick actions</small>
            <div className="d-flex  align-items-start  justify-content-start gap-2 py-2 ">

                <button className="btn btn-dark text-success" onClick={() => onAction('CALL')} >
                    <i className="fa-solid fa-phone "></i>
                </button>

                <button className="btn btn-dark text-danger" onClick={() => onAction('ALARM')} >
                    <i className="fa-solid fa-podcast"></i>
                </button>
                <button className="btn btn-dark " onClick={() => onAction('SYNC')} >
                    <i className="fa-solid fa-rotate"></i>
                </button>
            </div>
        </div>
    );
}

export default HealthActionBar 